/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var cf_number_form = document.getElementById('tec-campaign-finance-search-number'),
      cf_adv_form = document.getElementById('tec-campaign-finance-search-advanced');

  if(cf_number_form) {
    var field_number_type = cf_number_form.querySelector('#form-number-search-type'),
        cont_field_number_report = cf_number_form.querySelector('#field-number-report'),
        cont_field_number_filer = cf_number_form.querySelector('#field-number-filer'),
        cont_field_number_pac = cf_number_form.querySelector('#field-number-pac'),
        cont_field_show_recent = cf_number_form.querySelector('#field-number-updated');

    cf_number_form.addEventListener('form-reset', (e) => {
      check_cf_number_form();
    });

    field_number_type.addEventListener('change', (e) => {
      // Fallback for browsers that don't support View Transitions:
      if (!document.startViewTransition) {
        check_cf_number_form();
      } else {
        document.startViewTransition(() => check_cf_number_form());
      }
    });

    setTimeout(function() {
      check_cf_number_form();
    }, 100);
  }

  function check_cf_number_form() {
    console.log('field_number_type.value', field_number_type.value);

    if(field_number_type.value === 'report') {
      tec_search_form_field_show(cont_field_number_report);
      tec_search_form_field_hide(cont_field_number_filer);
      tec_search_form_field_hide(cont_field_number_pac);
    } else if(field_number_type.value === 'filer_id') {
      tec_search_form_field_hide(cont_field_number_report);
      tec_search_form_field_show(cont_field_number_filer);
      tec_search_form_field_hide(cont_field_number_pac);
    } else if(field_number_type.value === 'pac') {
      tec_search_form_field_hide(cont_field_number_report);
      tec_search_form_field_hide(cont_field_number_filer);
      tec_search_form_field_show(cont_field_number_pac);
    } else {
      tec_search_form_field_hide(cont_field_number_report);
      tec_search_form_field_hide(cont_field_number_filer);
      tec_search_form_field_hide(cont_field_number_pac);
    }
  }

  if(cf_adv_form) {
    var field_trans_type = cf_adv_form.querySelector('#form-advanced-trans-type'),
        field_search_type = cf_adv_form.querySelector('#form-advanced-search-type'),
        field_date_type = cf_adv_form.querySelector('#form-advanced-date-type'),
        cont_field_duplicate = cf_adv_form.querySelector('#field-form-adv-include-duplicates'),
        cont_field_duplicate_text = cf_adv_form.querySelector('#field-duplicates-text'),
        cont_field_date_year = cf_adv_form.querySelector('#field-date-type-year'),
        cont_field_date_range = cf_adv_form.querySelector('#field-date-type-range'),
        cont_field_filer_id = cf_adv_form.querySelector('#field-filer-id'),
        cont_field_filer_type = cf_adv_form.querySelector('#field-filter-type'),
        cont_field_name_searching_method = cf_adv_form.querySelector('#field-name-searching-method'),
        cont_field_entity_last_name = cf_adv_form.querySelector('#field-entity-last-name'),
        cont_field_entity_first_name = cf_adv_form.querySelector('#field-entity-first-name'),
        cont_block_narrow_error_info = cf_adv_form.querySelector('#form-narrow-error-info'),
        cont_field_narrow_city = cf_adv_form.querySelector('#form-advanced-city'),
        cont_field_narrow_state = cf_adv_form.querySelector('#form-advanced-state'),
        cont_field_narrow_zipcode = cf_adv_form.querySelector('#form-advanced-zipcode'),
        cont_field_narrow_employer_name = cf_adv_form.querySelector('#form-advanced-employer-name'),
        cont_field_narrow_occupation = cf_adv_form.querySelector('#form-advanced-occupation'),
        cont_field_narrow_description = cf_adv_form.querySelector('#form-adv-description'),
        cont_field_narrow_entity_name = cf_adv_form.querySelector('#field-narrow-entity-name'),
        cont_field_employee = cf_adv_form.querySelector('#field-employed'),
        cont_field_employee_text = cf_adv_form.querySelector('#field-employed-text'),
        accordion_container = cf_adv_form.querySelector('.accordion'),
        accordion_button = cf_adv_form.querySelector('#finance-report-narrow-control'),
        accordion_contents = cf_adv_form.querySelectorAll('.accordion-content'),
        form_reset = cf_adv_form.querySelector('button.js-form-reset'),
        transition_fields = [field_trans_type, field_date_type, field_search_type];

    cf_adv_form.addEventListener('form-reset', (e) => {
      check_cf_number_form();
    });

    transition_fields.forEach((transition_field) => {
      transition_field.addEventListener('change', (e) => {
        // Fallback for browsers that don't support View Transitions:
        if (!document.startViewTransition) {
          check_cf_adv_form();
        } else {
          document.startViewTransition(() => check_cf_adv_form());
        }
      });
    });

    form_reset.addEventListener('click', (e) => {
      // Fallback for browsers that don't support View Transitions:
      if (!document.startViewTransition) {
        check_cf_adv_form();
      } else {
        document.startViewTransition(() => check_cf_adv_form());
      }
    });

    setTimeout(function() {
      check_cf_adv_form();
    }, 100);
  }

  function check_cf_adv_form() {
    if(field_trans_type.value !== '') {
      tec_search_form_field_show(cont_field_duplicate, false);
      tec_search_form_field_show(cont_field_duplicate_text, false);

      if(field_trans_type.value === '1') {
        tec_search_form_field_show(cont_field_employee, false);
        tec_search_form_field_show(cont_field_employee_text, false);
      } else {
        tec_search_form_field_hide(cont_field_employee, false);
        tec_search_form_field_hide(cont_field_employee_text, false);
      }
    } else {
      tec_search_form_field_hide(cont_field_duplicate, false);
      tec_search_form_field_hide(cont_field_duplicate_text, false);
      tec_search_form_field_hide(cont_field_employee, false);
      tec_search_form_field_hide(cont_field_employee_text, false);
    }

    if(field_trans_type.value !== '' && field_date_type.value === 'year') {
      tec_search_form_field_show(cont_field_date_year);
      tec_search_form_field_hide(cont_field_date_range);
    } else if(field_trans_type.value !== '' && field_date_type.value === 'range') {
      tec_search_form_field_hide(cont_field_date_year);
      tec_search_form_field_show(cont_field_date_range);
    } else {
      tec_search_form_field_hide(cont_field_date_year);
      tec_search_form_field_hide(cont_field_date_range);
    }

    if(field_date_type.value !== '' && field_search_type.value === 'filer_id') {
      tec_search_form_field_show(cont_field_filer_id);
      tec_search_form_field_show(cont_field_filer_type);
      tec_search_form_field_hide(cont_field_name_searching_method, false);
      tec_search_form_field_hide(cont_field_entity_last_name, false);
      tec_search_form_field_hide(cont_field_entity_first_name, false);
      tec_search_form_field_show(cont_field_narrow_entity_name, false);
      tec_search_form_field_hide(cont_block_narrow_error_info, false);
      cont_field_narrow_city.classList.remove('field-adv-required');
      cont_field_narrow_state.classList.remove('field-adv-required');
      cont_field_narrow_zipcode.classList.remove('field-adv-required');
      cont_field_narrow_employer_name.classList.remove('field-adv-required');
      cont_field_narrow_occupation.classList.remove('field-adv-required');
      cont_field_narrow_description.classList.remove('field-adv-required');
    } else if(field_date_type.value !== '' && field_search_type.value === 'name') {
      if(cont_field_entity_last_name.classList.contains('hidden') && !accordion_container.classList.contains('open')) {
        accordion_button.click();
      }

      tec_search_form_field_hide(cont_field_filer_id);
      tec_search_form_field_hide(cont_field_filer_type);
      tec_search_form_field_show(cont_field_name_searching_method, false);
      tec_search_form_field_show(cont_field_entity_last_name, false);
      tec_search_form_field_show(cont_field_entity_first_name, false);
      tec_search_form_field_hide(cont_field_narrow_entity_name, false);
      tec_search_form_field_show(cont_block_narrow_error_info, false);
      cont_field_narrow_city.classList.add('field-adv-required');
      cont_field_narrow_state.classList.add('field-adv-required');
      cont_field_narrow_zipcode.classList.add('field-adv-required');
      cont_field_narrow_employer_name.classList.add('field-adv-required');
      cont_field_narrow_occupation.classList.add('field-adv-required');
      cont_field_narrow_description.classList.add('field-adv-required');
    } else {
      tec_search_form_field_hide(cont_field_filer_id);
      tec_search_form_field_hide(cont_field_filer_type);
      tec_search_form_field_hide(cont_field_name_searching_method, false);
      tec_search_form_field_hide(cont_field_entity_last_name, false);
      tec_search_form_field_hide(cont_field_entity_first_name, false);
      tec_search_form_field_hide(cont_field_narrow_entity_name, false);
      tec_search_form_field_hide(cont_block_narrow_error_info, false);
      cont_field_narrow_city.classList.remove('field-adv-required');
      cont_field_narrow_state.classList.remove('field-adv-required');
      cont_field_narrow_zipcode.classList.remove('field-adv-required');
      cont_field_narrow_employer_name.classList.remove('field-adv-required');
      cont_field_narrow_occupation.classList.remove('field-adv-required');
      cont_field_narrow_description.classList.remove('field-adv-required');
    }

    accordion_contents.forEach((accordion_content) => {
      var is_open = accordion_content.parentNode.classList.contains('open');

      if(is_open) {
        accordion_content.style.maxHeight = accordion_content.scrollHeight + "px";
      }
    });
  }
}());
